import React, { useEffect, useState } from 'react';
import PageLayout from './../layouts/PageLayout';
import Rating from '@mui/material/Rating';
import { Link } from 'react-router-dom';
import Swal from "sweetalert";

function Pricing() {
  const [value, setValue] = useState("1");
  const [firstName, setFirstName] = useState("");
  const [message, setMessage] = useState("");

  function handleFirstName(e) {
    setFirstName(e.target.value);
  }
  function handleMessage(e) {
    setMessage(e.target.value);
  }

  function sendReview(e) {
    e.preventDefault();
    const currentDateTime = new Date();
    const year = currentDateTime.getFullYear();
    const month = (currentDateTime.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDateTime.getDate().toString().padStart(2, '0');
    const dateFormatted = `${year}-${month}-${day}`;
    const hours = currentDateTime.getHours().toString().padStart(2, '0');
    const minutes = currentDateTime.getMinutes().toString().padStart(2, '0');
    const seconds = currentDateTime.getSeconds().toString().padStart(2, '0');
    const timeFormatted = `${hours}:${minutes}:${seconds}`;
    const dateTimeString = `${dateFormatted} ${timeFormatted}`;

    const data = {
      value: value,
      name: firstName,
      message: message,
      time: dateTimeString
    };

    fetch("https://pine-d8386-default-rtdb.firebaseio.com/data/myData.json", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)
    }).then(() => {
      Swal({
        title: "Thanks!",
        text: "Your review helps us grow.",
        icon: "success"
      });
      setFirstName("");
      setMessage("");
    }).catch(() => {});
  }

  useEffect(() => {
    fetch("https://pine-d8386-default-rtdb.firebaseio.com/data.json")
      .then((res) => res.json())
      .catch(() => {});
  }, []);

  return (
    <>
      <div className="page-content">
        <PageLayout desc="Share your experience and help others in Kelowna find great duct cleaning service." pageTitle="Reviews" />
        <section className="content-inner contact-form-wraper style-1">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-7 col-lg-7">
                <div className="contact-box">
                  <div className="card">
                    <div className="card-body">
                      <div className="mb-4">
                        <h2 className="mb-0">Add a Review</h2>
                        <p className="mb-0 font-18 text-primary">Had your ducts cleaned by us? We’d love to hear from you.</p>
                      </div>
                      <form className="dzForm" onSubmit={sendReview}>
                        <div className="col-xl-6 mb-3 mb-md-4" style={{ display: 'flex', alignItems: 'center' }}>
                          <span>Rating (1 to 5) –</span> &nbsp;&nbsp;
                          <Rating name="simple-controlled" value={Number(value)} onChange={(e, newValue) => setValue(String(newValue != null ? newValue : 1))} />
                        </div>
                        <div className="dzFormMsg"></div>
                        <div className="row">
                          <div className="col-xl-6 mb-3 mb-md-4">
                            <input name="dzFirstName" type="text" className="form-control" placeholder="Name" value={firstName} onChange={handleFirstName} />
                          </div>
                          <div className="col-xl-12 mb-3 mb-md-4">
                            <textarea name="dzMessage" className="form-control" placeholder="Your review" value={message} onChange={handleMessage}></textarea>
                          </div>
                          <div className="col-xl-12">
                            <button name="submit" type="submit" value="Submit" className="btn btn-primary">Submit</button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-5 col-lg-5 m-b30">
                <div className="info-box">
                  <div className="info">
                    <h2>Recent Reviews</h2>
                    <p className="font-18">What our Kelowna customers are saying about our duct cleaning service.</p>
                  </div>

                  <div className="dz-info">
                    <div className="dz-meta">
                      <ul>
                        <li className="post-author"><Link to={"#"}>Henry K.</Link></li>
                        <li className="post-date"><Link to={"#"}>18 November 2024</Link></li>
                        <p className="m-b0">Great work by professionals. Ducts are clean and the house smells fresher.</p>
                        <Rating readOnly value={5} />
                      </ul>
                    </div>
                    <div className="dz-meta">
                      <ul>
                        <li className="post-author"><Link to={"#"}>Rodriguez</Link></li>
                        <li className="post-date"><Link to={"#"}>12 May 2024</Link></li>
                        <p className="m-b0">On time, efficient, and fair pricing. Very happy with the result.</p>
                        <Rating readOnly value={5} />
                      </ul>
                    </div>
                    <div className="dz-meta">
                      <ul>
                        <li className="post-author"><Link to={"#"}>Mathew N.</Link></li>
                        <li className="post-date"><Link to={"#"}>11 April 2024</Link></li>
                        <p className="m-b0">Excellent duct cleaning and dryer vent service. Highly recommend Kelowna Duct Cleaning.</p>
                        <Rating readOnly value={5} />
                      </ul>
                    </div>
                    <div className="dz-meta">
                      <ul>
                        <li className="post-author"><Link to={"#"}>Rajinder K.</Link></li>
                        <li className="post-date"><Link to={"#"}>2 January 2024</Link></li>
                        <p className="m-b0">Professional from start to finish. Clean Air Kelowna delivered as promised.</p>
                        <Rating readOnly value={5} />
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default Pricing;
